import z from 'zod';

const MAX_SIZE_BYTES = 10 * 1024; // 10KB

export const flowValidator = z
  .object({
    flow: z.string(),
    step: z.string(),
    fromStart: z.number().positive(),
    fromLastEvent: z.number().positive()
  })
  .catchall(z.any())
  .superRefine((value, ctx) => {
    const encoder = new TextEncoder();
    const bytes = encoder.encode(JSON.stringify(value)).length;

    if (bytes > MAX_SIZE_BYTES) {
      ctx.addIssue({
        code: 'custom',
        message: 'Payload size must be less than 10KB'
      });
    }
  });
